/* eslint-disable no-empty-pattern */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  IS_LOGGED: false,
  TOKEN: null,
  ROLE: null,
  PERMISSIONS: {},
};

export const authSlice = createSlice({
  name: "auth",
  initialState,

  reducers: {
    USER_ROLE: (state, { payload }) => {
      state.ROLE = payload;
    },
    USER_DATA: (state, { payload }) => {
      state.TOKEN = payload.TOKEN;
      state.IS_LOGGED = payload.IS_LOGGED;
    },
    USER_LOGOUT: (state, { payload }) => {
      state.TOKEN = payload.TOKEN;
      state.IS_LOGGED = payload.IS_LOGGED;
      window.location.href = "/login";
    },
    USER_PERMISSIONS: (state, { payload }) => {
      state.PERMISSIONS = payload;
    },
  },
});

export const { USER_DATA, USER_LOGOUT, USER_ROLE, USER_PERMISSIONS } =
  authSlice.actions;

export default authSlice.reducer;
